import React from "react"
import { Header } from "@/landing-page/modules/header"
import { Hero } from "@/landing-page/modules/hero"
import { LookForTalent } from "@/landing-page/modules/look-for-talent"
import { Manifestations } from "@/landing-page/modules/manifestations"
import { Doubts } from "@/landing-page/modules/doubts"
import { Footer } from "@/landing-page/modules/footer"
import { Cookies } from "@/landing-page/components/cookies"
import AgencyTags from "@/components/agencytags"
import Helmet from "react-helmet"

const GTAG_HOME = process.env.GATSBY_GTAG_HOME || null

export default function LandingPage() {
  return (
    <>
      <Helmet>
        {GTAG_HOME && <script id="gtag-script" async src={`https://www.googletagmanager.com/gtag/js?id=${GTAG_HOME}`}></script>}
        
        <script id="gtag-script-function">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GTAG_HOME || "not-set"}');
          `}
        </script>
      </Helmet>
      <AgencyTags/>

      <div className="w-full absolute lg:top-2 lg:flex hidden justify-center z-50 text-white font-bold">Ministério da Cultura e Cartão Elo apresentam:</div>

      <Header/>
      <main className="overflow-hidden relative">
        <Hero/>
        <LookForTalent/>
        <Manifestations/>
        <Doubts />

        <Cookies />
      </main>
      <Footer/>
    </>
  )
}
